export default {"src":"/_next/static/media/rub.dd16c36d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};